import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {PreferenciaHomeService} from '../services/preferencia-home.service';

/**
 * O que abre em `/admin/index`.
 *
 * A rota continua sendo `/admin/index` para todo mundo — menu "Início", logo,
 * redirect do login, guards e os outros pontos que apontam para lá seguem
 * valendo sem alteração. Quem decide qual das duas homes aparece é a escolha
 * guardada no navegador, e ela vale na hora: o convite da home antiga e o
 * "voltar" da faixa de prévia trocam a tela sem recarregar nem mudar a URL.
 */
@Component({
  selector: 'app-home-switch',
  template: `
    <app-home-v2 *ngIf="usarHomeNova"></app-home-v2>
    <app-home *ngIf="!usarHomeNova"></app-home>
  `
})
export class HomeSwitchComponent implements OnInit, OnDestroy {
  usarHomeNova = false;

  private inscricao: Subscription;

  constructor(private preferenciaHome: PreferenciaHomeService) {}

  ngOnInit() {
    this.inscricao = this.preferenciaHome.mudou.subscribe((nova: boolean) => this.usarHomeNova = nova);
  }

  ngOnDestroy() {
    if (this.inscricao) this.inscricao.unsubscribe();
  }
}
